export enum MazFeedbackFlag {
  incorrect = 'incorrect',
  correct = 'correct',
}
